import { Info } from 'lucide-react';
import { useT } from '../../i18n';
import { PROJECT_ROLES, ASSIGNABLE_ROLES, getProjectRole } from './projectRoles';

// [Proposition: roles-projet] Role picker for a team member (Cadrage tab).
// Hovering the picker — or the role name when read-only — shows that role's
// explanation; each option carries its own explanation as a tooltip too.
// The project's sponsor always shows "Sponsor", locked: the sponsor is only
// ever set in the project's Sponsor field.
export function ProjectRoleSelect({ value, onChange, isSponsor = false, readOnly = false }: {
  value: string;
  onChange: (role: string) => void;
  /** This member is the project's sponsor (Sponsor field). */
  isSponsor?: boolean;
  readOnly?: boolean;
}) {
  const { t } = useT();
  if (isSponsor) {
    return (
      <span className="alloc-name project-role-label" title={`${t('roles.sponsor')} — ${t('roles.sponsor.desc')}\n${t('roles.sponsorFromField')}`}>
        {t('roles.sponsor')}
      </span>
    );
  }
  const current = getProjectRole(value === 'sponsor' ? '' : value);
  const tooltip = current ? `${t(current.labelKey)} — ${t(current.descKey)}` : t('roles.none.desc');

  if (readOnly) {
    return <span className="alloc-name project-role-label" title={tooltip}>{current ? t(current.labelKey) : '—'}</span>;
  }
  return (
    <select className="form-input--bare project-role-select" value={current?.id ?? ''} title={tooltip} onChange={(e) => onChange(e.target.value)}>
      <option value="" title={t('roles.none.desc')}>{t('roles.none')}</option>
      {ASSIGNABLE_ROLES.map(r => (
        <option key={r.id} value={r.id} title={t(r.descKey)}>{t(r.labelKey)}</option>
      ))}
    </select>
  );
}

// "Rôle ⓘ" column header — hovering it lists the four roles and what each means.
export function ProjectRolesHeader() {
  const { t } = useT();
  const all = PROJECT_ROLES.map((r, i) => `${i + 1}. ${t(r.labelKey)} — ${t(r.descKey)}`).join('\n');
  return (
    <span className="project-role-header" title={`${all}\n\n${t('roles.sponsorFromField')}`}>
      {t('roles.header')} <Info size={11} />
    </span>
  );
}
